module.exports = __webpack_public_path__ + "static/media/number-1-normal.da6dd112.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/numbers/number-1-normal.svg
// module id = 275
// module chunks = 0